export default defineNuxtPlugin(() => {
    const { spritePaths } = useSpriteData()

    useHead({
        link: [{
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: spritePaths.default,
            fetchpriority: 'low',
            key: spritePaths.default,
        }],
    })
})
